import { useState } from 'react'

import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper'
import { GET_AD_UNIT_BIDDERS } from './api/query'
import { AdUnitBidderSliceDTO, Data, Variables } from './api/types'
import { AdUnitBidderSlice, UseGetAdUnitBidders, UseGetAdUnitBiddersProps } from './types'

export const useGetAdUnitBidders = ({
  adUnitId,
}: UseGetAdUnitBiddersProps): UseGetAdUnitBidders => {
  const [adUnitBidders, setAdUnitBidders] = useState<AdUnitBidderSlice[] | undefined>()

  useQuery<Variables, Data>({
    onCompleted: async data => {
      const {
        adUnitBidders: { nodes: bidders },
      } = data

      if (bidders) {
        setAdUnitBidders(
          bidders.map((bidder: AdUnitBidderSliceDTO): AdUnitBidderSlice => fromDTO(bidder)),
        )
      }
    },
    options: {
      enabled: adUnitId !== undefined,
    },
    query: GET_AD_UNIT_BIDDERS,
    variables: {
      adUnitId: adUnitId!,
    },
  })

  return { adUnitBidders }
}
